/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment settings barrel
 *
 * @author Satyaki Bose
 * @file index.js
 */

import React from 'react';
import GradebookInfoModal from './GradebookInfoModal';
import { AssignmentSettingsFormStylesRoot, classes } from './styles/assignmentSettingsFormStyles';

export { default as AssignmentSettingsForm } from './AssignmentSettingsForm';
export { default as GradebookInfoModal } from './GradebookInfoModal';

export const GradebookInfoModalWithStyles = (props) => (
  <AssignmentSettingsFormStylesRoot>
    <GradebookInfoModal {...props} classes={classes} />
  </AssignmentSettingsFormStylesRoot>
);
export {
  defaultConfig as assignmentSettingsFormDefaultConfig,
  GRADEBOOK_DISPLAY_MODE,
  LATE_WORK_DEADLINE_TYPE,
  ASSIGNMENT_AVAILABILITY,
  EMPTY_ASSIGNMENT_SETTINGS_VALUES
} from './utils/assignmentSettingsConstants';
export {
  mergeAssignmentSettingsConfig,
  computeAssignmentSettingsVisibility,
  resolveAssignmentSettingsVisibility,
  getVisibleSections
} from './utils/assignmentSettingsFormConfig';
export {
  buildFormDefaultValues as buildAssignmentSettingsFormDefaultValues
} from './utils/assignmentSettingsFormUtils';
